interface IPersonalInfoCard {
  value: number | string;
  valueFontSize?: string;
  label: string;
  icon: React.ReactNode;
  color: string;
  isReverse?: boolean;
  spanClassName?: string;
}

const PersonalInfoCard = ({
  value,
  valueFontSize,
  label,
  icon,
  color,
  isReverse,
  spanClassName,
}: IPersonalInfoCard) => {
  // rendering personal info card component here
  return (
    <div
      style={{ borderColor: color }}
      className={`rounded-md flex flex-col items-center justify-start p-3 shadow-academia-sm border-t-4 space-y-3 ${
        spanClassName && spanClassName
      }`}
    >
      <figure className='flex items-center justify-center'>{icon}</figure>

      <figcaption
        className={`flex items-center justify-end self-stretch flex-1 text-center ${
          isReverse ? 'flex-col-reverse' : 'flex-col'
        } ${valueFontSize && 'gap-1'}`}
      >
        <h4
          style={{ color }}
          className={`font-medium w-full truncate text-wrap ${
            valueFontSize ? valueFontSize : 'text-3xl'
          }`}
        >
          {value}
        </h4>
        <p className='text-lg text-base-dark-blue capitalize'>{label}</p>
      </figcaption>
    </div>
  );
};

export default PersonalInfoCard;
